<div class="layer-sidebar">

    <div class="wrapper">
        <div class="layers-header">
            <div class="layers-title">
                Layers
            </div>
            <div class="header-actions">
                <inline-svg src="Help.svg" color="#A5B5BD" hoverColor="#7F8F98" class="header-help"
                            matTooltip="View layer descriptions"
                            (click)="openHelpModal()"></inline-svg>
            </div>
        </div>
        <nav class="tab-bar">
            <div class="tab" [class.tab-selected]="activeTab === 'basemap'" (click)="getActiveTab('basemap')">Basemaps
            </div>
            <div class="tab" [class.tab-selected]="activeTab === 'layers'" (click)="getActiveTab('layers')">Layers</div>
        </nav>
        <div class="section-divider"></div>
        <div class="content">
            @if (activeTab === 'basemap') {
                <div class="basemap-container" (wheel)="onWheel($event)">
                    <div class="basemap-options">
                        <label class="basemap-option" [ngClass]="{'selected': selectedBasemap === 'topographic'}">
                            <input type="radio" name="basemap" value="topographic" [(ngModel)]="selectedBasemap"
                                   (change)="onBasemapChange()">
                            @if (selectedBasemap === 'topographic') {
                                <div class="basemap-icon">
                                </div>
                            }
                            <div class="spacer"></div>
                            <span>Topographic</span>
                            <img [src]="getThumbImage('topographic')" alt="layer-tile">
                        </label>
                        <label class="basemap-option" [ngClass]="{'selected': selectedBasemap === 'satellite'}">
                            <input type="radio" name="basemap" value="satellite" [(ngModel)]="selectedBasemap"
                                   (change)="onBasemapChange()">
                            @if (selectedBasemap === 'satellite') {
                                <div class="basemap-icon">
                                </div>
                            }
                            <div class="spacer"></div>
                            <span>Satellite</span>
                            <img [src]="getThumbImage('satellite')" alt="layer-tile">
                        </label>
                    </div>
                </div>
            }
            @if (activeTab === 'layers') {
                <div class="layers-container"
                     cdkDropList
                     (cdkDropListDropped)="drop($event)"
                     (wheel)="onWheel($event)" [formGroup]="layersGroup">
                    @for (layer of layers; track layer) {
                        @if (layer.layer.name !== 'water') {
                            <div class="layer-item" [formGroupName]="layer.layer.name" cdkDrag cdkDragLockAxis="y">
                                <div class="drag-zone" cdkDragHandle>
                                    <inline-svg src="drag.svg" class="drag-icon" color="#A5B5BD"
                                                hoverColor="#7F8F98" parentClass="drag-zone"></inline-svg>
                                    <inline-svg src="drag.svg" class="drag-icon-active" color="#5E84F7"
                                                hoverColor="#5E84F7" parentClass="drag-zone"></inline-svg>
                                </div>
                                <div class="item-container"
                                     (click)="toggleActiveLayer(layer.layer.name)"
                                     [ngClass]="{'active': layersGroup.get(layer.layer.name).value.active}">
                                    <div class="layer-header">
                                        <img [src]="getThumbImage(layer.layer.name)" alt="layer-tile">
                                        <h2 class="info-title">{{ layer.layer.name }} {{ getUnitSymbol(layer.layer.unit) }}</h2>
                                        <div class="spacer"></div>
                                        <mat-slide-toggle formControlName="active" (click)="$event.stopPropagation()"></mat-slide-toggle>
                                    </div>
                                    @if (layersGroup.get(layer.layer.name).value.active) {
                                        @if (isLinearLayer(layer)) {
                                            <mat-checkbox
                                                    (click)="$event.stopPropagation()"
                                                    [checked]="isSelected(layer.layer.name)"
                                                    (change)="invertLayer(layer.layer.name)">
                                                Invert
                                            </mat-checkbox>
                                            <frmg-gradient-slider [min]="layer.layer.min_threshold"
                                                                  [max]="layer.layer.max_threshold"
                                                                  [max]="layer.layer.max_threshold"
                                                                  [invert]="isSelected(layer.layer.name)"
                                                                  [trackGradient]="gradients[layer.layer.name]"
                                                                  formControlName="range"
                                                                  (click)="$event.stopPropagation()"
                                                                  style="
                                                                  --overlay-left: rgba(255,255,255,0.2);
                                                                  --overlay-middle: rgba(255,255,255,0.04);
                                                                  --overlay-right: rgba(255,255,255,0.2);"
                                            ></frmg-gradient-slider>
                                        } @else {
                                            <frmg-gradient-selector [data]="layer.layer.colormap_values"
                                                                    [value_descriptions]="layer.layer.value_descriptions"
                                                                    formControlName="selected"
                                                                    (click)="$event.stopPropagation()"
                                                                    [requireAtLeastOne]="true">
                                            </frmg-gradient-selector>
                                        }
                                    }
                                </div>
                            </div>
                        }
                    }
                </div>
            }
        </div>
    </div>
</div>